export enum OrderType {
  Basic = 1,
  Maintanace = 2,
  Express = 4,
  Visit = 5,
  ReInspection = 6,
  DynamicServices = 8
}
